/*Default tab design for mobile responsive navigation */


import React, { Component } from 'react';
import '../../css/container/defaultTab.css';
import { Nav, NavItem,NavLink} from 'reactstrap';
import scriptLoader from 'react-async-script-loader'

class DefaultTab extends Component{

  componentWillUnmount () {
    window.location.reload();
  }

  render (){


    return (

    <div className="container_Tab tab ">

        <div className="bg-color">

          <Nav className="vam nav scroll ">
          <NavItem  className="tab_nav-item" onClick={() => this.props.action("BCM Dashboard")}>BCM Dashboard</NavItem>
          <NavItem  className="tab_nav-item" data-id="blog-2" aria-controls="blog-2">BCM Module</NavItem>
          {/* <NavItem  className="tab_nav-item"onClick={() => this.props.action("BCM Report")}>BCM Report</NavItem> */}
          {/* <NavItem  className="tab_nav-item" onClick={() => this.props.action("BCM Admin")} >BCM Admin</NavItem> */}
          <NavItem  className="tab_nav-item"  onClick={() => this.props.action("System Admin")} >System Admin</NavItem>
          </Nav>

        </div>


        <div className=" bg-color submenu scroll " id="blog-2">
           <NavItem  className="tab_nav-item"  onClick={() => this.props.action("BCM Admin")}>BCM Admin</NavItem>
           <NavItem  className="tab_nav-item"   onClick={() => this.props.action("BCM User")}>BCM User</NavItem>
        </div>

    </div>

  );
  }
}

export default scriptLoader(
    process.env.PUBLIC_URL + '/js/DefaultTab/tab.js',
  )(DefaultTab)
